import React, { useCallback, useEffect, useState,useRef } from "react";
import MPHInput from "src/components/DataProviders/MPHInput";
import MPHButton from "../MPHButtons/MPHButton";
import "./MPHLogin.scss";
import modalClose from "../../../assets/images/modalClose.png";
import MPHOtp from "../MPHOtp/MPHOtp";
import {
  loginSchema,
  loginValidation,
  signUpSchema,
  signUpValidation,
} from "src/utils/MPHFormsSchemaValidations/MPHFormsSchemaValidations";
import { useApiAxiosRequests } from "src/utils/ApiService/MPHApis";
import { useFormik } from "formik";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { errorToast, successToast } from "src/utils/toast";
import { AUTH_ROUTES, BASIC_SSO_AUTH, BRAND_NAME, CHAIN_ID, DEVICE_ID, HOTEL_FIND_LINK } from "src/config/constants";
import useAuth from "src/context/AuthContext";
import MPHForgotPassword from "../MPHForgotPassword/MPHForgotPassword";
import MPHOptIn from "../MPHOptIn/MPHOptIn";
import { useStorage } from "src/utils/storage";
import { useBlockUIContext } from "ns-react-block-ui";
import MPHSweepstakes from "../MPHSweepstakes/MPHSweepstakes";

const errorCodes: Record<string, string> = {
  "1515": "User doesn't exist. Please try again.",
  "1527": "User doesn't exist. Please try again.",
  "1528": "Password entered is invalid, Please try again.",
  "400": "Profile not found"
}

const MPHLogin = ({ screenType }: any) => {
  const storage = useStorage();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';
  const promotion = searchParams.get('promotion') || '';
  const acquisitionChannel = searchParams.get("acquisition_channel") || "web";
  const rewardredeem = searchParams.get('rewardredeem') || 'false';
  const reward = searchParams.get('reward') || '';
  const rewardCode = reward.trim();
  const guestRedirectURL = `${process.env.REACT_APP_FIND_HOTEL_LINK}signin?chain=19777`; //URL as provided in SDD
  storage.set("promotion", promotion);
  const updatedLoginSchema = {
    ...loginSchema,
    identifierValue: email,
  };
  const updatedSignUpSchema = {
    ...signUpSchema,
    identifierValue: email,
  };
  const [isOtp, setIsOtp] = useState(false);
  const [isUpdateUser, setIsUpdateUser]: any = useState(false);
  const [isCreatePassword, setIsCreatePassword]: any = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [registeredForPassword, setRegisteredForPassword] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const [initialValues] = useState(updatedLoginSchema);
  const [initialValuesSetPassword] = useState(updatedSignUpSchema);
  const { setTokens, setUserProfile, optIn, setOptIn, tokens, user } = useAuth();
  const loyaltyPoints = user?.loyalty_points || 0;
  const hasAuthSession = Boolean(tokens?.token || tokens?.accessToken);
  const hasSweepstakesParams =
    promotion === "true" &&
    rewardredeem === "true" &&
    rewardCode !== "";
  const canAutoShowSweepstakes =
    hasSweepstakesParams && hasAuthSession && loyaltyPoints >= 1000;
  const [isRewardRedeem, setIsRewardRedeem] = useState<boolean>(
    () => canAutoShowSweepstakes
  );
  const handleRewardLogout = useCallback(() => {
    setIsRewardRedeem(false);
  }, []);
  const [externalId, setExternalId] = useState("");
  // const [isReservationRedirecting, setIsReservationRedirecting] = useState(false);
  const navigate = useNavigate(); //useNavigate hook
  const location = useLocation();
  const isReservationModifyLogin = location.pathname.includes("/login_reservation_modify");
  const isUserLoggedIn = Boolean(tokens?.accessToken || tokens?.token);
  const showContinueAsGuest = isReservationModifyLogin && !isUserLoggedIn;
  const modifyReservationFormRef = useRef<HTMLFormElement | null>(null);
  const redirectUrl = `${HOTEL_FIND_LINK}reservation-list`;
  const { setBlockUI } = useBlockUIContext();

  useEffect(() => {
    if (canAutoShowSweepstakes && !isRewardRedeem) {
      setIsRewardRedeem(true);
    }
  }, [canAutoShowSweepstakes, isRewardRedeem]);

  const {
    passwordValidate,
    getCustomerByEmail,
    tokenGenerate,
    otpGenerate,
    otpValidate,
    getCustomerByEmailLoggedIn,
    getCRMSession,
    getCustomerLookUpAuthToken,
    getCustomerLookUp,
    updateCustomer
  } = useApiAxiosRequests();

  const tokenGenerateFunc = async () => {
    const payload = {
      identifierType: "EMAIL",
      identifierValue: values.identifierValue.toLowerCase(),
      password: values.password,
      confirmPassword: values.password,
      deviceId: DEVICE_ID,
      brand: BRAND_NAME,
    };
    const res: any = await tokenGenerate(payload);
    if (res.data && res.data.status && res.data.status.success) {
      setRegisteredForPassword(res.data.user.userRegisteredForPassword);
      setSessionId(res.data.user.sessionId);
    }
    return {
      status: res.data && res.data.status && res.data.status.success,
      data: res.data,
    };
  };

  const updateCustomerFunc = async () => {
    generateOtpFunc({ sessionId: sessionId }, true);
  };
  
  const getSession = async (
    profileId?: string,
    hasRetried = false,
    emailValue?: string
  ): Promise<{ session?: string; error?: string }> => {
    const storedProfile: any = storage.get("user_profile");
    let parsedStore: any;

    try {
      parsedStore = storedProfile ? JSON.parse(storedProfile) : null;
    } catch (error) {
      console.error("Failed to parse user profile from storage", error);
      return { error: "Unable to place request" };
    }

    const emailFromStorage =
      parsedStore && parsedStore.email ? parsedStore.email.toLowerCase() : "";
    const email = (emailValue || emailFromStorage || "").toLowerCase();

    if (!email) {
      return { error: "Unable to place request" };
    }

    setIsLoading(true);
    try {
      const params = {
        identifierName: "email",
        identifierValue: email,
      };
      const res: any = await getCustomerLookUp(params);
      if (!(res && res.data && res.data.id)) {
        return { error: "Unable to place request" };
      }

      const token: any = await getCustomerLookUpAuthToken(
        {
          GrantType: "CLIENT_CREDENTIALS",
          UserIPAddress: "127.0.0.1",
          UserType: "Hotel",
          BusinessContext: "WBSVC",
        },
        BASIC_SSO_AUTH,
        email
      );
      if (!(token?.data?.access_token)) {
        return { error: "Unable to place request" };
      }

      let memberId;
      if (
        res.data?.profiles &&
        res.data.profiles.length &&
        res.data.profiles[0].identifiers &&
        res.data.profiles[0].identifiers.length
      ) {
        const identifier = res.data.profiles[0].identifiers.find(
          (val: any) => val.type === "externalId"
        );
        memberId = identifier?.value;
      }

      const crmSession: any = await getCRMSession(
        {
          ChainId: CHAIN_ID,
          IDContext: "CRM",
          ProfileID: profileId || memberId || res.data.id,
          UserType: "Guest",
        },
        { token: token.data.access_token },
        email
      );

      if (crmSession?.data?.access_token) {
        return { session: crmSession.data.access_token };
      }

      if (!hasRetried && memberId && res.data.id) {
        return await getSession(res.data.id, true, email);
      }

      return {
        error: crmSession?.data?.error_description || "Unable to place request",
      };
    } catch (error) {
      console.error("Failed to get CRM session for modify reservation", error);
      return { error: "Unable to place request" };
    } finally {
      setIsLoading(false);
    }
  };

  const updateModifyReservationForm = (sessionValue: string) => {
    const form = modifyReservationFormRef.current;
    if (!form) {
      return false;
    }

    const payload: Record<string, string> = {
      chain: CHAIN_ID ? String(CHAIN_ID) : "",
      Level: "Chain",
      "code-type": "promo",
      locale: "en_US",
      UserType: "Guest",
      session: sessionValue,
    };

    Object.entries(payload).forEach(([key, value]) => {
      const input = form.elements.namedItem(key) as HTMLInputElement | null;
      if (input) {
        input.value = value;
      } else {
        const hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = key;
        hiddenInput.value = value;
        form.appendChild(hiddenInput);
      }
    });

    return true;
  };

  const createBodyForFormPost = async (email: string) => {
    const normalizedEmail = email ? email.toLowerCase() : "";
    const { session, error } = await getSession(undefined, false, normalizedEmail);
    if (session) {
      const formUpdated = updateModifyReservationForm(session);
      if (formUpdated) {
        modifyReservationFormRef.current?.submit();
      } else {
        errorToast("Unable to place request");
        setBlockUI({ blocking: false });
      }
    } else {
      // setIsReservationRedirecting(false);
      errorToast(error || "Unable to place request");
      setBlockUI({ blocking: false });
    }
  };

  const handleSaveNext = async () => {
    let payload: any = values;
    payload.identifierValue = payload.identifierValue.toLowerCase()
    let userDetails: any;
    setIsLoading(true);
    userDetails = await tokenGenerateFunc();
    if (!userDetails.status) {
      errorToast(
        (userDetails.data &&
          userDetails.data.status &&
          userDetails.data.status.message) ||
        "Please check username password. Your entry did not match our records"
      );
      setIsLoading(false);
      return;
    }
    if (!userDetails.data.user.userRegisteredForPassword) {
      const data: any = await getCustomerByEMailFunc(
        values.identifierValue.toLowerCase(),
        userDetails.data.auth.token
      );
      if (data.data && data.data.customers !== "LOYALTY") {
        errorToast("User does not exist, Please validate email");
        setIsLoading(false);
        return;
      }
      if (
        data &&
        data.data &&
        data.data.status &&
        data.data.status.success === "true"
      ) {
        setIsUpdateUser(true);
        setIsLoading(false);
        return;
      } else if (!data?.data?.customers) {
        errorToast("User does not exist, Please validate email");
        setIsLoading(false);
        return;
      }
      generateOtpFunc(userDetails.data.user);
      return;
    }
    payload["sessionId"] = userDetails.data.user.sessionId;
    const res: any = await passwordValidate(payload);
    if (res && res.data && res.data.status && !res.data.status.success) {
      const errorMessage = res.data.status?.code === 1528 ? "Invalid password. Please try again." : res.data.status?.message;
      setIsLoading(false);
      errorToast(errorMessage);
      return;
    }
    if (res && res.data && res.data.status && res.data.status.success) {
      if (res.data.auth && res.data.auth.token) {
        handleLoginSuccess(res.data.auth, res.data.status.message);
      }
    } else {
      errorToast((res && res.data && res.data.message) || "Error logging In");
    }
    setIsLoading(false);
  };

  const handleLoginSuccess = async (auth: any, message?: any) => {
    const user: any = await getCustomerByEmailLoggedIn(
      { email: values.identifierValue.toLowerCase() },
      auth.token
    );
    if (
      !user?.data?.status?.success ||
      user?.data?.status?.success === "false"
    ) {
      navigate("/signup", {
        state: {
          isDropOut: true,
          auth,
          email: values.identifierValue.toLowerCase(),
        },
      });
      return;
    }
    const customer: any =
      user &&
      user.data &&
      user.data.customers &&
      user.data.customers.customer &&
      user.data.customers.customer.length &&
      user.data.customers.customer[0];
    const memberExternalId = (customer && customer.external_id) || "";
    setExternalId(memberExternalId);
    setTokens(auth);
    setIsOtp(false);
    setIsCreatePassword(false);
    setIsForgotPassword(false);
    const profile = {
      method: "auth",
      email: values.identifierValue.toLowerCase(),
      previousStep: "",
      token: auth.token,
      role: "User",
      isProfileExist: true,
      links: AUTH_ROUTES,
      profileName: (customer && customer.firstname) || "",
      loyalty_points: (customer && customer.loyalty_points) || 0,
      external_id: memberExternalId,
    };
    setUserProfile(profile);

    if (isReservationModifyLogin) {
      setBlockUI({
        blocking: true,
      });
      // setIsReservationRedirecting(true);
      await createBodyForFormPost(values.identifierValue.toLowerCase());
      return;
    }

    setIsLoading(false);
    if (message) {
      successToast("Logged In Successfully");
    }
    // if (promotion === "true") {
    //   setOptIn(true);
    // } else {
    //   navigate("/status");
    // }
    if(promotion === "true" && rewardredeem === "true" && profile.loyalty_points >= 1000){
      setIsRewardRedeem(true);
    } else if (promotion === "true" && rewardredeem === "true" && profile.loyalty_points < 1000) {
      navigate("/find-hotels");
      errorToast("Points are low! Earn more to reach 1000.");
      
    } else if(promotion === "true" && rewardredeem === "false"){
      const payload = {
        root: {
          customer: [
            {
              email: profile.email,
              custom_fields: {
                field: [
                  {
                    name: "passport_entry",
                    value: acquisitionChannel,
                  }
                ]
              }
            }
          ]
        }
      };
      try {
        await updateCustomer(payload, auth.token, profile.email);  
      } catch (error) {
        console.error("Failed to update passport_entry on login", error);
      }
      setOptIn(true);      
    } else {
      navigate("/status");
    }
  };

  const getCustomerByEMailFunc = async (email: any, token: any) => {
    const data = await getCustomerByEmail({ email: email }, token);
    return data;
  };

  const generateOtpFunc = async (data: any, update?: any) => {
    let sessionIdForDirect: any;
    setIsLoading(true);
    if (isCreatePassword) {
      setFieldValue(
        "identifierValue",
        setPasswordFormik.values.identifierValue.toLowerCase()
      );
      const payload = {
        identifierType: "EMAIL",
        identifierValue: setPasswordFormik.values.identifierValue.toLowerCase(),
        password: setPasswordFormik.values.password,
        confirmPassword: setPasswordFormik.values.password,
        deviceId: DEVICE_ID,
        brand: BRAND_NAME,
      };
      const res: any = await tokenGenerate(payload);
      if (res.data && res.data.status && res.data.status.success) {
        setRegisteredForPassword(res.data.user.userRegisteredForPassword);
        setSessionId(res.data.user.sessionId);
        sessionIdForDirect = res.data.user.sessionId;
        const data: any = await getCustomerByEMailFunc(
          setPasswordFormik.values.identifierValue.toLowerCase(),
          res.data.auth.token
        );
        if (data.data && data.data.customers !== "LOYALTY") {
          errorToast("User does not exist, Please validate email");
          setIsLoading(false);
          return;
        }
      } else {
        errorToast("User does not exist, Please validate email");
        setIsLoading(false);
        return;
      }
    }
    let payload: any = {
      identifierType: values.identifierType,
      identifierValue: values.identifierValue.toLowerCase(),
      deviceId: values.deviceId,
      brand: values.brand,
      sessionId: sessionIdForDirect || data.sessionId,
    };
    if (update) {
      payload["password"] = setPasswordFormik.values.password;
      payload["confirmPassword"] = setPasswordFormik.values.password;
      payload["identifierValue"] = setPasswordFormik.values.identifierValue.toLowerCase();
    }
    const res: any = await otpGenerate(payload);
    setIsLoading(false);
    if (res.data && res.data.status && res.data.status.success) {
      successToast(res.data.status.message);
      setIsOtp(true);
    } else {
      errorToast(
        (res && res.data && res.data.status && res.data.status.message) ||
        "Error Generating in otp, Please try again"
      );
    }
  };

  const otpValidateFunc = async (otp: any) => {
    const payload: any = {
      identifierType: values.identifierType,
      identifierValue: values.identifierValue.toLowerCase(),
      deviceId: values.deviceId,
      brand: values.brand,
      sessionId: sessionId,
      otp: otp,
    };
    if (registeredForPassword || isCreatePassword) {
      payload["password"] = setPasswordFormik.values.password;
      payload["confirmPassword"] = setPasswordFormik.values.password;
      payload["identifierValue"] = setPasswordFormik.values.identifierValue.toLowerCase();
    }
    setIsLoading(true);
    const res: any = await otpValidate(payload);
    if (res.data && res.data.status && res.data.status.success) {
      handleLoginSuccess(res.data.auth, res.data.status.message);
    } else {
      errorToast(
        (res && res.data && res.data.status && res.data.status.message) ||
        "Error Validating otp, Please try again"
      );
    }
    setIsLoading(false);
  };

  const handleContinueAsGuest = () => {
    window.location.assign(guestRedirectURL);
  };

  const formik = useFormik({
    initialValues,
    validationSchema: loginValidation,
    enableReinitialize: true,
    validateOnMount: true,
    onSubmit: handleSaveNext,
  });

  const setPasswordObj = useFormik({
    initialValues: initialValuesSetPassword,
    validationSchema: signUpValidation,
    enableReinitialize: true,
    validateOnMount: true,
    onSubmit: handleSaveNext,
  });
  const setPasswordFormik = setPasswordObj;

  const {
    values,
    handleChange,
    setFieldValue,
    handleBlur,
    errors,
    touched,
    isValid,
  } = formik;

  //changes made to show error based on code from url
  useEffect(() => {
    const code = searchParams.get("code");
    if (!code) {
      return;
    }

    const message = errorCodes[code];
    if (message) {
      errorToast(message);
    }
  }, [searchParams]);

  useEffect(() => {
    if (screenType === "create-password") {
      setIsCreatePassword(true);
      setIsUpdateUser(true);
      setIsOtp(false);
      setIsForgotPassword(false);
    }
    if (screenType === "forgot-password") {
      setIsCreatePassword(false);
      setIsUpdateUser(false);
      setIsOtp(false);
      setIsForgotPassword(true);
    }
  }, [screenType]);

  return (
    <>
      <div className="d-flex justify-center">
        <section className="login-modal" style={isRewardRedeem ? { width: "65%" } :{}}>
          {!optIn && !isRewardRedeem && <>
            {isForgotPassword ? (
              <>
                <MPHForgotPassword
                  isModal={false}
                  onModalClose={() => {
                    setIsForgotPassword(false);
                    setIsCreatePassword(false);
                    setIsUpdateUser(false);
                    setIsOtp(false);
                    if (screenType === "forgot-password") {
                      navigate("/login");
                    }
                  }}
                />
              </>
            ) : (
              <>
                {!isOtp ? (
                  isUpdateUser ? (
                    <>
                      <div className="modal-content login-form-modal">
                        <div className="row">
                          <section className="mb-3">
                            <h2 className="form-header">
                              {isCreatePassword
                                ? "Create your password"
                                : "Confirm Password"}
                            </h2>
                            <img
                              className="close-modal"
                              src={modalClose}
                              alt=""
                              onClick={() => {
                                setIsForgotPassword(false);
                                setIsCreatePassword(false);
                                setIsUpdateUser(false);
                                setIsOtp(false);
                              }}
                            />
                          </section>
                          <div className="col-12 mt-3">
                            <MPHInput
                              keyboardType="email"
                              placeholder="Email"
                              value={setPasswordFormik.values.identifierValue}
                              isModal={true}
                              onBlur={setPasswordFormik.handleBlur(
                                "identifierValue"
                              )}
                              onChangeText={(text: any) => {
                                setPasswordFormik.handleChange("identifierValue")(
                                  text
                                );
                              }}
                              isError={
                                setPasswordFormik.touched.identifierValue! &&
                                !!setPasswordFormik.errors.identifierValue
                              }
                              error={setPasswordFormik.errors.identifierValue}
                            />
                          </div>
                          <div className="col-12 mt-4">
                            <MPHInput
                              keyboardType="password"
                              placeholder="Password"
                              value={setPasswordFormik.values.password}
                              onBlur={setPasswordFormik.handleBlur("password")}
                              onChangeText={(text: any) => {
                                setPasswordFormik.handleChange("password")(text);
                              }}
                              isError={touched.password! && !!errors.password}
                              error={errors.password}
                              isModal={true}
                            />
                          </div>
                          <div className="col-12 mt-4">
                            <MPHInput
                              keyboardType="password"
                              placeholder="Confirm Password"
                              value={setPasswordFormik.values.confirmPassword}
                              onBlur={setPasswordFormik.handleBlur(
                                "confirmPassword"
                              )}
                              onChangeText={(text: any) => {
                                setPasswordFormik.handleChange("confirmPassword")(
                                  text
                                );
                              }}
                              isError={
                                setPasswordFormik.touched.confirmPassword! &&
                                !!setPasswordFormik.errors.confirmPassword
                              }
                              error={setPasswordFormik.errors.confirmPassword}
                              isModal={true}
                            />
                          </div>
                          <div className="col-12 mt-4">
                            <MPHButton
                              disabled={!setPasswordFormik.isValid || isLoading}
                              isLoading={isLoading}
                              buttonText="Submit"
                              onbuttonClick={() => updateCustomerFunc()}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="modal-content login-form-modal">
                        <div className="row">
                          <section className="mb-3">
                            <h2 className="form-header">Login</h2>
                          </section>
                          <div className="col-12 mt-3">
                            <MPHInput
                              keyboardType="email"
                              placeholder="Email"
                              value={values.identifierValue}
                              isModal={true}
                              onBlur={handleBlur("identifierValue")}
                              onChangeText={(text: any) => {
                                handleChange("identifierValue")(text);
                              }}
                              isError={
                                touched.identifierValue! &&
                                !!errors.identifierValue
                              }
                              error={errors.identifierValue}
                            />
                          </div>
                          <div className="col-12 mt-4">
                            <MPHInput
                              keyboardType="password"
                              placeholder="Password"
                              value={values.password}
                              onBlur={handleBlur("password")}
                              onChangeText={(text: any) => {
                                handleChange("password")(text);
                              }}
                              isError={touched.password! && !!errors.password}
                              error={errors.password}
                              isModal={true}
                            />
                          </div>
                          <div className="col-12">
                            <h3
                              className="forgot-password mt-1"
                              onClick={() => {
                                navigate("/forgot-password");
                              }}
                            >
                              Forgot your password?
                            </h3>
                          </div>
                          <div className="col-12">
                            <h3 className="first-time-sign-in mt-1">
                              First time signing in?
                              <span
                                onClick={() => {
                                  setIsUpdateUser(true);
                                  setIsCreatePassword(true);
                                }}
                                className="forgot-password ml-1"
                              >
                                Create your password
                              </span>
                            </h3>
                          </div>
                          <div className="col-12 mt-4">
                            <MPHButton
                              disabled={!isValid || isLoading}
                              isLoading={isLoading}
                              buttonText="Login"
                              onbuttonClick={() => handleSaveNext()}
                            />
                          </div>
                          {showContinueAsGuest && (
                            <div className="col-12 mt-2">
                              <MPHButton
                                disabled={isLoading}
                                isLoading={false}
                                buttonText="Continue as a guest"
                                onbuttonClick={handleContinueAsGuest}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  )
                ) : (
                  <MPHOtp
                    text={values.identifierValue}
                    isLoading={isLoading}
                    isModal={false}
                    darkTheme={true}
                    resend={() => generateOtpFunc({ sessionId: sessionId })}
                    onClose={() => {
                      setIsOtp(false);
                      setIsUpdateUser(false);
                      setIsForgotPassword(false);
                      setIsCreatePassword(false);
                    }}
                    onOtp={(otp: any) => otpValidateFunc(otp)}
                  />
                )}
              </>
            )}
          </>}

         {optIn && <MPHOptIn acquisitionChannel={acquisitionChannel} isLogin={true} />}
         {isRewardRedeem && (
           <MPHSweepstakes
             acquisitionChannel={acquisitionChannel}
             reward={rewardCode}
             externalId={externalId}
             isLogin={true}
             onRequireLogin={handleRewardLogout}
           />
         )}
        </section>
      </div>
      <form
        ref={modifyReservationFormRef}
        action={redirectUrl}
        method="POST"
        style={{ display: "none" }}
      >
        <input type="hidden" name="hotel" defaultValue="" />
        <input
          type="hidden"
          name="chain"
          defaultValue={CHAIN_ID ? String(CHAIN_ID) : ""}
        />
        <input type="hidden" name="Level" defaultValue="Chain" />
        <input type="hidden" name="adult" defaultValue="" />
        <input type="hidden" name="arrive" defaultValue="" />
        <input type="hidden" name="depart" defaultValue="" />
        <input type="hidden" name="rooms" defaultValue="" />
        <input type="hidden" name="code-type" defaultValue="promo" />
        <input type="hidden" name="promo" defaultValue="" />
        <input type="hidden" name="locale" defaultValue="en_US" />
        <input type="hidden" name="UserType" defaultValue="Guest" />
        <input type="hidden" name="session" defaultValue="" />
      </form>
    </>
  );
};

export default MPHLogin;
//comment for git